export const accountCancelReasons = [
  { key: "0", value: "Do Not Like" },
  { key: "1", value: "Better Product Available" },
  { key: "2", value: "It is Expensive" },
  { key: "3", value: "Can Improve" },
  { key: "4", value: "Some Other Reason" },
];

